module.exports = __webpack_public_path__ + "img/screenshot-code-perspective.8f02761e.png";